(function() {

  class Footer {
    constructor(element) {
      if(!element) return;

      this.element = element;
      this.init();
    }

    init() {

      const goTotopButton = document.querySelector('.u-page__go-to-top-button');

      if (goTotopButton) {
        goTotopButton.addEventListener('click', () => {
          gsap.to(window, {duration: 1, scrollTo: 0 });
        });
      }

      const goToTopWrapper = document.querySelector('.u-page__go-to-top-wrapper');

      var isFixed = false;
      var isVisible = false;

      window.addEventListener('scroll', () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        const parallaxWrapperOffsetTop = this.element.closest('.u-parallax').offsetTop;
        const bottomLine = st + window.innerHeight;
        const shouldBeVisible = st > window.innerHeight;

        const footerPadding = parseInt(window.getComputedStyle(document.querySelector('.u-footer')).paddingBottom);
        const shouldBeFixed = parallaxWrapperOffsetTop + footerPadding < bottomLine;

        if(shouldBeFixed !== isFixed) {
          isFixed = shouldBeFixed;
          if(shouldBeFixed) {
            goToTopWrapper.classList.add('u-page__go-to-top-wrapper--fixed');
          } else {
            goToTopWrapper.classList.remove('u-page__go-to-top-wrapper--fixed');
          }
        };

        if(shouldBeVisible !== isVisible) {
          isVisible = shouldBeVisible;
          if(shouldBeVisible) {
            goToTopWrapper.classList.add('u-page__go-to-top-wrapper--visible');
          } else {
            goToTopWrapper.classList.remove('u-page__go-to-top-wrapper--visible');
          }
        }
        
      }, false);

    }
  }

  new Footer(document.querySelector('.u-footer'))

})();